import {
  Component,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  Input,
  ViewChild,
} from '@angular/core';
import { UserResponse } from '@app/store/user';
import { ThemeService } from '@app/services';
import { HttpClient } from '@angular/common/http';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import * as fromUser from '@app/store/user';

// Imports de Asistencia
import * as fromAsistencia from '@app/pages/asistencias/store/asistencia.actions';
import * as AsistenciaSelectors from '@app/pages/asistencias/store/asistencia.selectors';

import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { GeneralService } from '@app/services/general.service';
import { DebounceClickService } from '@app/services/debounce-click.service';
import { environment } from '@src/environments/environment';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Output() menuToggle = new EventEmitter<void>();
  @Input() user!: UserResponse | null;
  @Input() isAuthorized!: boolean | null;
  @Input() isMobile!: boolean;
  @Output() signOut = new EventEmitter<void>();

  // 🔥 NUEVO: Referencia al trigger del menú para poder cerrarlo programáticamente
  @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;

  // Propiedades
  roleUser: string = '';
  horaPeru: Date = new Date();
  horaEspana: Date = new Date();
  ventasPendientes: number = 0;
  isDarkMode = false;
  idUsuario: number | null = null;
  private subscription = new Subscription();

  // Estados de asistencia para la UI, se actualizan desde el store
  breakActivo: boolean = false;
  banoActivo: boolean = false;
  totalBreaks: number = 0;
  totalBanos: number = 0;
  puedeTomarBreak: boolean = true;
  puedeIrAlBano: boolean = true;
  horaSalida: string | null = null;
  breakLoading: boolean = false;
  banoLoading: boolean = false;
  salidaLoading: boolean = false;

  // 🔥 NUEVO: Estados para iniciar asistencia
  asistenciaLoading: boolean = false;
  yaInicioAsistencia: boolean = false;
  yaMarcoSalida: boolean = false; // 🔥 NUEVO: Si ya marcó salida

  // 🔥 NUEVO: Estados para salida de emergencia
  emergenciaLoading: boolean = false;

  // 🔥 NUEVO: Timer para verificar auto-finalizaciones del backend
  private autoCheckTimer: any = null;

  constructor(
    private themeService: ThemeService,
    private http: HttpClient,
    private store: Store,
    private router: Router,
    private generalService: GeneralService,
    private debounceClickService: DebounceClickService
  ) {}

  ngOnInit(): void {
    this.actualizarHoras();
    setInterval(() => this.actualizarHoras(), 1000);
    this.suscribirATema();
    this.cargarDatosDeUsuarioYRefrescarEstado();
    this.suscribirAEstadoAsistencia();

    const usuario = this.generalService.usuario$;

    if (usuario) {
      this.roleUser = usuario.role || '';
      this.idUsuario = usuario.id || null;
      if (
        this.roleUser === 'BACKOFFICE' ||
        this.roleUser === 'BACKOFFICETRAMITADOR' ||
        this.roleUser === 'BACKOFFICESEGUIMIENTO'
      ) {
        this.obtenerVentasPendientes();
      }
    } else {
      const userFromLocalStorage = localStorage.getItem('user');
      if (userFromLocalStorage) {
        const user = JSON.parse(userFromLocalStorage);
        this.roleUser = user.role || '';
        this.idUsuario = user.id || null;

        if (
          this.roleUser === 'BACKOFFICE' ||
          this.roleUser === 'BACKOFFICETRAMITADOR' ||
          this.roleUser === 'BACKOFFICESEGUIMIENTO'
        ) {
          this.obtenerVentasPendientes();
        }
      } else {
        console.warn('No se encontró información del usuario.');
      }
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.detenerVerificacionAutomatica();
  }

  // 1. Carga el usuario y despacha la acción para refrescar el estado del header
  private cargarDatosDeUsuarioYRefrescarEstado(): void {
    this.subscription.add(
      this.store.pipe(select(fromUser.getUser)).subscribe((usuario) => {
        if (usuario && usuario.id) {
          this.user = usuario;
          this.idUsuario = usuario.id;
          this.roleUser = usuario.role || '';

          // 🔥 INTELIGENTE: Solo refrescar si no hay datos en el store
          this.store
            .pipe(
              select((state: any) => state.asistencia),
              take(1)
            )
            .subscribe((asistenciaState: any) => {
              const tieneEstadoActividades =
                asistenciaState?.breakActivo !== undefined ||
                asistenciaState?.banoActivo !== undefined;

              // Solo refrescar si no hay estado de actividades
              if (!tieneEstadoActividades) {
                console.log(
                  'Header: Usuario detectado sin datos. Despachando HeaderMenuAbierto.'
                );
                this.store.dispatch(new fromAsistencia.HeaderMenuAbierto());
              }
            });

          if (this.debeCargarVentasPendientes()) {
            this.obtenerVentasPendientes();
          }
        }
      })
    );
  }

  // 2. Se suscribe a los cambios del store para actualizar la UI
  private suscribirAEstadoAsistencia(): void {
    // 🔥 CORREGIDO: Solo usar el selector combinado para evitar conflictos
    this.subscription.add(
      this.store
        .pipe(select(AsistenciaSelectors.selectHeaderState))
        .subscribe((state) => {
          // Detectar cambios en actividades activas para manejar verificación automática
          const actividadActivaAnterior = this.breakActivo || this.banoActivo;

          // Actualizamos todas las propiedades del componente de golpe
          this.breakActivo = state.breakActivo;
          this.banoActivo = state.banoActivo;
          this.totalBreaks = state.totalBreaks;
          this.totalBanos = state.totalBanos;
          this.puedeTomarBreak = state.puedeTomarBreak;
          this.puedeIrAlBano = state.puedeIrAlBano;
          this.yaInicioAsistencia = state.yaRegistroEntrada;
          this.yaMarcoSalida = state.yaMarcoSalida;
          this.breakLoading = state.loadingBreak;
          this.banoLoading = state.loadingBano;
          this.salidaLoading = state.loadingSalida;
          this.asistenciaLoading = state.loadingAsistencia;
          // 🔥 NUEVO: Manejar verificación automática cuando hay actividades activas
          const actividadActivaActual = this.breakActivo || this.banoActivo;

          if (actividadActivaActual && !actividadActivaAnterior) {
            // Se activó una actividad, iniciar verificación automática
            console.log(
              '🔄 Header: Actividad detectada, iniciando verificación automática'
            );
            this.iniciarVerificacionAutomatica();
          } else if (!actividadActivaActual && actividadActivaAnterior) {
            // Se desactivaron todas las actividades, detener verificación automática
            console.log(
              '⏹️ Header: No hay actividades activas, deteniendo verificación automática'
            );
            this.detenerVerificacionAutomatica();
          }
        })
    );

    // Mantenemos la suscripción a errores por separado
    this.subscription.add(
      this.store
        .pipe(
          select(AsistenciaSelectors.selectAsistenciaError),
          filter((error) => !!error)
        )
        .subscribe((error) =>
          console.error(
            '❌ Header: Error recibido desde el store de asistencias:',
            error
          )
        )
    );
  }

  // --- ACCIONES DE ASISTENCIA ---

  // 🔥 REFACTORIZADO: Iniciar asistencia con debounce y cierre de menú
  onIniciarAsistencia(): void {
    if (!this.idUsuario || this.yaInicioAsistencia || this.yaMarcoSalida) {
      return;
    }

    // Usar debounce para evitar dobles clics
    const allowed = this.debounceClickService.setInProgress(
      'iniciar-asistencia',
      3000
    );
    if (!allowed) {
      return;
    }

    console.log(
      '🚀 Header: Iniciando asistencia para usuario:',
      this.idUsuario
    );

    // 🎉 NUEVO: Lanzar animación de confeti
    this.lanzarConfeti();

    this.store.dispatch(
      new fromAsistencia.IniciarAsistencia({ usuarioId: this.idUsuario })
    );

    // 🔥 NUEVO: Cerrar el menú inmediatamente después de despachar la acción
    if (this.menuTrigger) {
      this.menuTrigger.closeMenu();
    }
  }

  onBreakAction(): void {
    if (!this.idUsuario || this.yaMarcoSalida) return;

    // 🔥 VALIDACIÓN: No puede tomar break si no ha iniciado asistencia
    if (!this.yaInicioAsistencia && !this.breakActivo) {
      Swal.fire({
        title: '⚠️ Asistencia Requerida',
        text: 'Debe iniciar su asistencia antes de tomar un break.',
        icon: 'warning',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#f59e0b',
      });
      return;
    }

    // Usar debounce para evitar dobles clics
    const actionKey = this.breakActivo ? 'finalizar-break' : 'iniciar-break';
    const allowed = this.debounceClickService.setInProgress(actionKey, 2000);
    if (!allowed) {
      return;
    }

    const action = this.breakActivo
      ? new fromAsistencia.FinalizarBreak({ usuarioId: this.idUsuario })
      : new fromAsistencia.IniciarBreak({ usuarioId: this.idUsuario });
    this.store.dispatch(action);
  }

  onBanoAction(): void {
    if (!this.idUsuario || this.yaMarcoSalida) return;

    // 🔥 VALIDACIÓN: No puede ir al baño si no ha iniciado asistencia
    if (!this.yaInicioAsistencia && !this.banoActivo) {
      Swal.fire({
        title: '⚠️ Asistencia Requerida',
        text: 'Debe iniciar su asistencia antes de ir al baño.',
        icon: 'warning',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#f59e0b',
      });
      return;
    }

    // Usar debounce para evitar dobles clics
    const actionKey = this.banoActivo ? 'finalizar-bano' : 'iniciar-bano';
    const allowed = this.debounceClickService.setInProgress(actionKey, 2000);
    if (!allowed) {
      return;
    }

    const action = this.banoActivo
      ? new fromAsistencia.FinalizarBano({ usuarioId: this.idUsuario })
      : new fromAsistencia.IniciarBano({ usuarioId: this.idUsuario });
    this.store.dispatch(action);
  }

  onMarcarSalida(): void {
    if (!this.idUsuario || this.yaMarcoSalida) return;

    // 🔥 VALIDACIÓN: No puede marcar salida si no ha iniciado asistencia
    if (!this.yaInicioAsistencia) {
      Swal.fire({
        title: '⚠️ Asistencia Requerida',
        text: 'Debe iniciar su asistencia antes de marcar la salida.',
        icon: 'warning',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#f59e0b',
      });
      return;
    }

    // 🔥 VALIDACIÓN: Debe haber tomado al menos 2 breaks
    if (this.totalBreaks < 2) {
      Swal.fire({
        title: '⚠️ Breaks Requeridos',
        text: `Debe completar al menos 2 breaks antes de marcar la salida. Breaks completados: ${this.totalBreaks}/2`,
        icon: 'warning',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#f59e0b',
      });
      return;
    }

    // Usar debounce para evitar dobles clics
    const allowed = this.debounceClickService.setInProgress(
      'marcar-salida',
      3000
    );
    if (!allowed) {
      return;
    }

    this.store.dispatch(
      new fromAsistencia.MarcarSalida({ usuarioId: this.idUsuario })
    );
  }

  // 🔥 NUEVO: Método para salida de emergencia (sin validar breaks)
  onSalidaEmergencia(): void {
    if (!this.idUsuario || this.yaMarcoSalida) return;

    // 🔥 VALIDACIÓN: No puede marcar salida si no ha iniciado asistencia
    if (!this.yaInicioAsistencia) {
      Swal.fire({
        title: '⚠️ Asistencia Requerida',
        text: 'Debe iniciar su asistencia antes de marcar la salida de emergencia.',
        icon: 'warning',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#f59e0b',
      });
      return;
    }

    // 🔥 CONFIRMACIÓN: Advertencia sobre salida de emergencia
    Swal.fire({
      title: '🚨 Salida de Emergencia',
      text: '¿Está seguro que desea salir de emergencia? Esta acción no validará los breaks obligatorios.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, Salir de Emergencia',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#dc2626',
      cancelButtonColor: '#6b7280',
    }).then((result) => {
      if (result.isConfirmed) {
        this.emergenciaLoading = true;

        // Llamar al endpoint de emergencia
        this.registrarSalidaEmergencia();
      }
    });
  }

  // 🔥 NUEVO: Método para registrar salida de emergencia
  private registrarSalidaEmergencia(): void {
    if (!this.idUsuario) return;

    const url = `${environment.url}api/asistencias/salida-emergencia`;

    this.http.post(url, { usuarioId: this.idUsuario }).subscribe({
      next: (response: any) => {
        this.emergenciaLoading = false;

        if (response.rpta === 1) {
          Swal.fire({
            title: '✅ Salida de Emergencia Registrada',
            text: 'Su salida ha sido registrada exitosamente. Los breaks no fueron validados.',
            icon: 'success',
            confirmButtonText: 'Entendido',
            confirmButtonColor: '#10b981',
          });

          // 🔥 OPTIMIZADO: Refrescar estado después de salida de emergencia
          this.store.dispatch(new fromAsistencia.HeaderMenuAbierto());
        } else {
          Swal.fire({
            title: '❌ Error en Salida de Emergencia',
            text: response.msg || 'Error al registrar la salida de emergencia.',
            icon: 'error',
            confirmButtonText: 'Entendido',
            confirmButtonColor: '#ef4444',
          });
        }
      },
      error: (error) => {
        this.emergenciaLoading = false;
        console.error('Error en salida de emergencia:', error);

        Swal.fire({
          title: '❌ Error de Conexión',
          text: 'No se pudo conectar con el servidor. Intente nuevamente.',
          icon: 'error',
          confirmButtonText: 'Entendido',
          confirmButtonColor: '#ef4444',
        });
      },
    });
  }

  // 🔥 OPTIMIZADO: Método para refrescar estado cuando se hace clic en el avatar
  onAvatarClick(): void {
    console.log('🔄 Header: Avatar clickeado - idUsuario:', this.idUsuario);
    if (!this.idUsuario) {
      console.log('❌ Header: No hay idUsuario, saliendo...');
      return;
    }
    // 🔥 ELIMINADO: HeaderRefrescarEstado - evitar llamadas innecesarias en clicks
    console.log(
      '🔄 Header: Click en avatar - no se refresca (datos ya actualizados)'
    );
  }

  // 🔥 REFACTORIZADO: Método que se ejecuta al hacer clic en el trigger del menú
  onMenuTriggerClick(): void {
    console.log(
      '🔄 Header: onMenuTriggerClick() ejecutado - idUsuario:',
      this.idUsuario
    );
    if (!this.idUsuario) {
      console.log('❌ Header: No hay idUsuario, saliendo...');
      return;
    }

    // Usar debounce para evitar múltiples clics rápidos en el menú
    const allowed = this.debounceClickService.setInProgress(
      'menu-trigger',
      1000
    );
    if (!allowed) {
      console.log('🚫 Header: Click en menú bloqueado - muy rápido');
      return;
    }

    // 🔥 NUEVO: Usar la acción específica para el menú
    console.log('🔄 Header: Despachando HeaderMenuAbierto');
    this.store.dispatch(new fromAsistencia.HeaderMenuAbierto());
  }

  // 🔥 SIMPLIFICADO: Solo para logging
  onMenuOpened(): void {
    console.log('🔄 Header: onMenuOpened() - Menú abierto visualmente');
    // No hacer nada más - el estado ya se cargó en onMenuTriggerClick
  }

  // --- LÓGICA DE NAVEGACIÓN ---
  goToAsistencias(): void {
    // Determinar la ruta según el rol del usuario
    const rolesAdmin = [
      'ADMIN',
      'PROGRAMADOR',
      'LECTOR',
      'RECURSOSHUMANOS',
      'RRHHJEFE',
      'COORDINADOR',
    ];
    const isAdminRole = rolesAdmin.includes(this.roleUser);
    const ruta = isAdminRole ? '/asistencias/admin' : '/asistencias/personal';

    // 🔥 OPTIMIZADO: NO hacer llamadas duplicadas al navegar
    if (isAdminRole) {
      console.log(
        'Usuario admin - navegando a vista administrativa (sin refresh duplicado)'
      );
      // 🔥 ELIMINADO: HeaderRefrescarEstado - el menú ya se encargó de refrescar
    } else {
      console.log('Usuario asesor - navegando a vista personal');
      // 🔥 SOLO para asesores: AsesorPaginaCargada (sin HeaderRefrescarEstado duplicado)
      this.store.dispatch(new fromAsistencia.AsesorPaginaCargada());
    }

    // Navega a la ruta correspondiente
    this.router.navigate([ruta]);
  }

  // --- MÉTODOS AUXILIARES Y DE UI ---

  getAsistenciaButtonClass(): string {
    if (this.asistenciaLoading)
      return 'border-gray-300 bg-gray-100 cursor-wait dark:border-gray-600 dark:bg-gray-700';
    if (this.yaMarcoSalida)
      // 🔥 NUEVO: Bloquear si ya marcó salida
      return 'border-gray-300 bg-gray-100 cursor-not-allowed opacity-50 dark:border-gray-600 dark:bg-gray-700';
    if (this.yaInicioAsistencia)
      return 'border-green-200 bg-green-50 hover:bg-green-100 dark:border-green-700 dark:bg-green-900/20 dark:hover:bg-green-900/40';
    return 'border-purple-200 bg-purple-50 hover:bg-purple-100 dark:border-purple-700 dark:bg-purple-900/20 dark:hover:bg-purple-900/40';
  }

  getBreakButtonClass(): string {
    if (this.breakLoading)
      return 'border-gray-300 bg-gray-100 cursor-wait dark:border-gray-600 dark:bg-gray-700';
    if (this.yaMarcoSalida)
      return 'border-gray-300 bg-gray-100 cursor-not-allowed opacity-50 dark:border-gray-600 dark:bg-gray-700';
    // 🔥 NUEVO: Bloquear si no ha iniciado asistencia
    if (!this.yaInicioAsistencia && !this.breakActivo)
      return 'border-gray-300 bg-gray-100 cursor-not-allowed opacity-50 dark:border-gray-600 dark:bg-gray-700';
    if (!this.puedeTomarBreak && !this.breakActivo)
      return 'border-gray-300 bg-gray-100 cursor-not-allowed opacity-50 dark:border-gray-600 dark:bg-gray-700';
    if (this.breakActivo)
      return 'border-orange-200 bg-orange-50 hover:bg-orange-100 dark:border-orange-700 dark:bg-orange-900/20 dark:hover:bg-orange-900/40';
    return 'border-yellow-200 bg-yellow-50 hover:bg-yellow-100 dark:border-yellow-700 dark:bg-yellow-900/20 dark:hover:bg-yellow-900/40';
  }

  getBanoButtonClass(): string {
    if (this.banoLoading)
      return 'border-gray-300 bg-gray-100 cursor-wait dark:border-gray-600 dark:bg-gray-700';
    if (this.yaMarcoSalida)
      return 'border-gray-300 bg-gray-100 cursor-not-allowed opacity-50 dark:border-gray-600 dark:bg-gray-700';
    // 🔥 NUEVO: Bloquear si no ha iniciado asistencia
    if (!this.yaInicioAsistencia && !this.banoActivo)
      return 'border-gray-300 bg-gray-100 cursor-not-allowed opacity-50 dark:border-gray-600 dark:bg-gray-700';
    if (!this.puedeIrAlBano && !this.banoActivo)
      return 'border-gray-300 bg-gray-100 cursor-not-allowed opacity-50 dark:border-gray-600 dark:bg-gray-700';
    if (this.banoActivo)
      return 'border-blue-200 bg-blue-50 hover:bg-blue-100 dark:border-blue-700 dark:bg-blue-900/20 dark:hover:bg-blue-900/40';
    return 'border-cyan-200 bg-cyan-50 hover:bg-cyan-100 dark:border-cyan-700 dark:bg-cyan-900/20 dark:hover:bg-cyan-900/40';
  }

  getSalidaButtonClass(): string {
    if (this.salidaLoading)
      return 'border-gray-300 bg-gray-100 cursor-wait dark:border-gray-600 dark:bg-gray-700';
    if (this.yaMarcoSalida)
      return 'border-green-200 bg-green-50 cursor-not-allowed dark:border-green-700 dark:bg-green-900/20';
    // 🔥 NUEVO: Bloquear si no ha iniciado asistencia o no ha completado 2 breaks
    if (!this.yaInicioAsistencia || this.totalBreaks < 2)
      return 'border-gray-300 bg-gray-100 cursor-not-allowed opacity-50 dark:border-gray-600 dark:bg-gray-700';
    return 'border-red-200 bg-red-50 hover:bg-red-100 dark:border-red-700 dark:bg-red-900/20 dark:hover:bg-red-900/40';
  }

  onMenuToggleDispatch(): void {
    this.menuToggle.emit();
  }
  toggleDarkMode(): void {
    this.themeService.toggleDarkMode();
  }

  private suscribirATema(): void {
    this.subscription.add(
      this.themeService.darkMode$.subscribe(
        (isDarkMode) => (this.isDarkMode = isDarkMode)
      )
    );
  }

  private actualizarHoras(): void {
    const ahora = new Date();
    this.horaPeru = new Date(
      ahora.toLocaleString('en-US', { timeZone: 'America/Lima' })
    );
    this.horaEspana = new Date(
      ahora.toLocaleString('en-US', { timeZone: 'Europe/Madrid' })
    );
  }

  isBACKOFFICETRAMITADOR(): boolean {
    return this.roleUser === 'BACKOFFICETRAMITADOR';
  }
  isBACKOFFICESEGUIMIENTO(): boolean {
    return this.roleUser === 'BACKOFFICESEGUIMIENTO';
  }
  isBACKOFFICE(): boolean {
    return this.roleUser === 'BACKOFFICE';
  }

  // ✅ MÉTODO AÑADIDO PARA CORREGIR EL ERROR
  private debeCargarVentasPendientes(): boolean {
    const rolesPermitidos = [
      'BACKOFFICE',
      'BACKOFFICETRAMITADOR',
      'BACKOFFICESEGUIMIENTO',
    ];
    return rolesPermitidos.includes(this.roleUser);
  }

  private obtenerVentasPendientes(): void {
    const baseUrl = `${environment.urlVentas}ventas/`;
    const url =
      this.isBACKOFFICE() || this.isBACKOFFICETRAMITADOR()
        ? baseUrl
        : `${baseUrl}/backoffice/${this.idUsuario}/`;

    const params = new URLSearchParams();
    params.append('estado', 'PENDIENTE DE FILTRO');

    this.http.get<any>(`${url}?${params}`).subscribe({
      next: (response) => {
        this.ventasPendientes = response.pagination.total_records || 0;
      },
      error: () => {
        // En caso de error, simplemente establecer a 0
        this.ventasPendientes = 0;
      },
    });
  }

  getFirstNameAndLastName(): string {
    if (!this.user) return 'Usuario';
    const firstName = this.user.nombre ? this.user.nombre.split(' ')[0] : '';
    const firstLastName = this.user.apellido
      ? this.user.apellido.split(' ')[0]
      : '';
    return `${firstName} ${firstLastName}`.trim();
  }

  onImageError(event: any): void {
    event.target.src = 'https://preline.co/assets/img/160x160/img1.jpg';
  }
  goToProfile(): void {
    this.router.navigate(['/auth/perfil']);
  }
  navigateToGmail(): void {
    this.router.navigate(['/correos']);
  }

  onSignOut(): void {
    this.signOut.emit();
  }

  openFacebook(): void {
    window.open(
      'https://www.facebook.com/Midassolutionscenteroficial',
      '_blank'
    );
  }
  openInstagram(): void {
    window.open(
      'https://www.instagram.com/midassolutionscenteroficial/?hl=es',
      '_blank'
    );
  }
  openTikTok(): void {
    window.open('https://www.tiktok.com/@midasolutionscenter', '_blank');
  }

  // 🔥 ELIMINADO: Método innecesario - usar directamente onBreakAction()

  // 🔥 NUEVO: Métodos para verificación automática
  private iniciarVerificacionAutomatica(): void {
    // Si ya hay un timer activo, no crear otro
    if (this.autoCheckTimer) {
      return;
    }

    console.log(
      '🔄 Header: Iniciando verificación automática cada 30 segundos'
    );

    // Verificar estado cada 30 segundos cuando hay actividades activas
    this.autoCheckTimer = setInterval(() => {
      if (this.idUsuario && (this.breakActivo || this.banoActivo)) {
        console.log(
          '🔄 Header: Verificando estado automáticamente (actividad activa detectada)'
        );
        // 🔥 OPTIMIZADO: Usar HeaderMenuAbierto en lugar de HeaderRefrescarEstado para verificación automática
        this.store.dispatch(new fromAsistencia.HeaderMenuAbierto());
      } else {
        // Si no hay actividades activas, detener la verificación automática
        console.log(
          '⏹️ Header: No hay actividades activas, deteniendo verificación'
        );
        this.detenerVerificacionAutomatica();
      }
    }, 90000); // 90 segundos
  }

  private detenerVerificacionAutomatica(): void {
    if (this.autoCheckTimer) {
      console.log('⏹️ Header: Deteniendo verificación automática');
      clearInterval(this.autoCheckTimer);
      this.autoCheckTimer = null;
    }
  }

  // 🎉 NUEVO: Método para lanzar animación de confeti
  private lanzarConfeti(): void {
    // Crear contenedor de confeti si no existe
    let contenedorConfeti = document.getElementById('confeti-container');
    if (!contenedorConfeti) {
      contenedorConfeti = document.createElement('div');
      contenedorConfeti.id = 'confeti-container';
      contenedorConfeti.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 9999;
        overflow: hidden;
      `;
      document.body.appendChild(contenedorConfeti);
    }

    // Colores vibrantes del confeti (similar a la imagen)
    const colores = [
      '#FFD700', // Dorado
      '#FF6B6B', // Rojo coral
      '#4ECDC4', // Turquesa
      '#45B7D1', // Azul cielo
      '#96CEB4', // Verde menta
      '#FECA57', // Amarillo
      '#FF9FF3', // Rosa
      '#54A0FF', // Azul
      '#5F27CD', // Púrpura
      '#00D2D3', // Cian
      '#FF9F43', // Naranja
      '#10AC84'  // Verde
    ];

    // Crear múltiples oleadas de confeti
    for (let oleada = 0; oleada < 3; oleada++) {
      setTimeout(() => {
        // Cada oleada tiene más piezas
        for (let i = 0; i < 25; i++) {
          setTimeout(() => {
            this.crearPiezaConfeti(contenedorConfeti!, colores);
          }, i * 30); // Más rápido para efecto más denso
        }
      }, oleada * 200); // Oleadas escalonadas
    }

    // Limpiar el contenedor después de la animación
    setTimeout(() => {
      if (contenedorConfeti && contenedorConfeti.parentNode) {
        contenedorConfeti.parentNode.removeChild(contenedorConfeti);
      }
    }, 5000);
  }

  private crearPiezaConfeti(contenedor: HTMLElement, colores: string[]): void {
    const pieza = document.createElement('div');
    const color = colores[Math.floor(Math.random() * colores.length)];

    // Variedad de tamaños y formas
    const tamaño = Math.random() * 10 + 6; // Entre 6px y 16px
    const ancho = tamaño + (Math.random() * 4 - 2); // Variación en ancho
    const alto = tamaño + (Math.random() * 4 - 2); // Variación en alto

    const posicionX = Math.random() * window.innerWidth;
    const rotacion = Math.random() * 360;
    const duracion = Math.random() * 2.5 + 2.5; // Entre 2.5s y 5s
    const retraso = Math.random() * 0.8; // Hasta 0.8s de retraso

    // Diferentes formas de confeti
    const formas = ['circle', 'square', 'triangle', 'star'];
    const forma = formas[Math.floor(Math.random() * formas.length)];

    let estilosForma = '';
    switch (forma) {
      case 'circle':
        estilosForma = 'border-radius: 50%;';
        break;
      case 'square':
        estilosForma = 'border-radius: 2px;';
        break;
      case 'triangle':
        estilosForma = `
          width: 0;
          height: 0;
          border-left: ${ancho/2}px solid transparent;
          border-right: ${ancho/2}px solid transparent;
          border-bottom: ${alto}px solid ${color};
          background-color: transparent;
        `;
        break;
      case 'star':
        estilosForma = `
          background-color: ${color};
          clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
        `;
        break;
    }

    pieza.style.cssText = `
      position: absolute;
      width: ${forma === 'triangle' ? ancho : ancho}px;
      height: ${forma === 'triangle' ? alto : alto}px;
      ${forma !== 'triangle' && forma !== 'star' ? `background-color: ${color};` : ''}
      top: -20px;
      left: ${posicionX}px;
      transform: rotate(${rotacion}deg);
      animation: caerConfeti ${duracion}s ease-in ${retraso}s forwards;
      opacity: 0.9;
      ${estilosForma}
    `;

    contenedor.appendChild(pieza);

    // Remover la pieza después de la animación
    setTimeout(() => {
      if (pieza.parentNode) {
        pieza.parentNode.removeChild(pieza);
      }
    }, (duracion + retraso) * 1000);
  }
}
